export function getRoute() {
  const path = window.location.pathname;
  const hash = window.location.hash;
  if (path === "/admin" || hash === "#/admin") return { page: "admin" };
  const eventMatch = path.match(/^\/event\/([^/]+)/) || hash.match(/^#\/event\/([^/]+)/);
  if (eventMatch) return { page: "event", id: eventMatch[1] };
  return { page: "home" };
}

export function navigate(path) {
  window.location.hash = path;
}
